import React, { type FC, type ReactElement, useEffect } from 'react'
import { Fab, Tooltip } from '@mui/material'
import { NoticesList } from './NoticesList'
import AddIcon from '@mui/icons-material/Add'
import { FetchNoticesAction, ToggleCreateNoticeModalAction } from '../../../redux/notices/notices-actions'
import { CreateNoticeDialog } from './CreateNoticeModal'
import { useTranslation } from 'react-i18next'
import { type RootState } from '../../../redux/store'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'

/**
 * Notices view to display notices and associated actions.
 */
export const NoticesView: FC = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(FetchNoticesAction())
  }, [dispatch])

  return (
        <NoticesContainer>
            <NoticeAdminManagementControls/>
            <NoticesList/>
        </NoticesContainer>
  )
}

/* Child-components */

type ChildrenType = ReactElement | ReactElement[]

function NoticeAdminManagementControls(): ReactElement | null {
  const isAdmin = useAppSelector((state: RootState) => state.auth.isAdmin)

  if (!isAdmin) {
    return null
  }

  return (
        <>
            <CreateNoticeDialog/>
            <CreateNoticeButton/>
        </>
  )
}

function NoticesContainer({ children }: Readonly<{ children: ChildrenType }>): ReactElement {
  return (
        <div style={{ /* backgroundColor: '#f9fbfd' */}}>
            {children}
        </div>
  )
}

function CreateNoticeButton(): ReactElement {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const openCreateNoticeModal = (): void => {
    dispatch(ToggleCreateNoticeModalAction())
  }

  return (
        <Tooltip title={t('notices.createNew')}>
            <Fab
                style={{ margin: '1em 2em' }}
                color='primary'
                onClick={openCreateNoticeModal}
            >
                <AddIcon/>
            </Fab>
        </Tooltip>
  )
}
